module.exports = __webpack_public_path__ + "img/Close.0f7c706d.svg";